import React from 'react'
import FullWidthImg from '../assets/full-width-img.png'

const FullBlade = () => {
  return (
    <div className='full-blade-img'>
         <img src={FullWidthImg} alt="Full Width" />
    </div>
  )
}

export default FullBlade